import * as React from 'react';
import { useTheme } from '@websky/core/src/theme';
import cn from 'classnames';
import css from './FlightCardCarrierName.css';
const FlightCardCarrierName = ({ flightNumber, airline, aircraft }) => {
    const theme = useTheme('FlightCard').FlightCard;
    const isLujoBlackJet = aircraft.name.includes('Boeing 757-200 Lujo Black Jet');
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: theme.airline__number }, flightNumber),
        React.createElement("span", { className: theme.airline__name }, airline.name),
        isLujoBlackJet && React.createElement("span", { className: cn(theme.airline__name, css.lujo) }, "Lujo Black Jet")));
};
export default FlightCardCarrierName;
